import { render, staticRenderFns } from "./bridge.vue?vue&type=template&id=f5e2e7e6&"
import script from "./bridge.vue?vue&type=script&lang=js&"
export * from "./bridge.vue?vue&type=script&lang=js&"
import style0 from "./bridge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports